/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/community.scss';
import _PopReservationClassRoom from './_PopReservationClassRoom';
import _PopManageReservation from './_PopManageReservation';

const ReservationRoom = () => {
  const [modalClassRoomOpen, setModalClassRoomOpen] = useState(false);
  const [modalReservationOpen, setModalReservationOpen] = useState(false);
  const rooms = ['인수실', 101, 102, 201, 202, 203, 204, 205, 301, 302, 303, 501, 502];

  return (
    <main className="com_container p_reservation_room">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu5_7 ">강의실 예약</h2>
          <div className="com_btn_wrap">
            <button onClick={() => setModalClassRoomOpen(true)} className="com_btn orange s btn_settings">
              강의실 관리
            </button>
            <button onClick={() => setModalReservationOpen(true)} className="com_btn orange s btn_plus">
              강의실 예약
            </button>
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            <div className="com_calendar_wrap ">
              <div className="year">
                <button className="com_btn line gray s">오늘</button>
                <button className="btn btn_first"></button>
                <button className="btn btn_prev"></button>
                <button className="btn_txt">2022 </button>
                <button className="btn btn_next"></button>
                <button className="btn btn_last"></button>
              </div>
              <div className="year">
                <button className="btn btn_first"></button>
                <button className="btn btn_prev"></button>
                <button className="btn_txt">08 </button>
                <button className="btn btn_next"></button>
                <button className="btn btn_last"></button>
              </div>
              <div className="year">
                <button className="btn btn_first"></button>
                <button className="btn btn_prev"></button>
                <button className="btn_txt">31(수)</button>
                <button className="btn btn_next"></button>
                <button className="btn btn_last"></button>
              </div>
            </div>
            <section className="reservation_calendar">
              <ul className="time_header">
                <li className="title">강의실 명</li>
                <li className="time">09:00</li>
                <li className="time">09:30</li>
                <li className="time">10:00</li>
                <li className="time">11:00</li>
                <li className="time">12:00</li>
                <li className="time">13:00</li>
                <li className="time">14:00</li>
                <li className="time">15:00</li>
                <li className="time">16:00</li>
                <li className="time">17:00</li>
                <li className="time">18:00</li>
                <li className="time">19:00</li>
                <li className="time">20:00</li>
                <li className="time">21:00</li>
              </ul>
              <div className="room_schedule">
                <div className="time_schedule_grid">
                  <ul className="room_cell">
                    {rooms.map((item) => (
                      <li key={item} className="room">
                        {item}
                      </li>
                    ))}
                  </ul>
                  <ul className="schedule_cell">
                    {rooms.map((item, index) => {
                      if (index === 2) {
                        return <li key={index} className="time bg"></li>;
                      }

                      return (
                        <li key={item} className="time">
                          {index === 8 && (
                            <div className="schedule_box" style={{top: '300px', height: '60px', width: '206px'}}>
                              [교육] 김예약103 <br />
                              신규교사 면접으로
                            </div>
                          )}
                        </li>
                      );
                    })}
                  </ul>
                  <ul className="schedule_cell">
                    {rooms.map((item, index) => {
                      if (index === 2) {
                        return <li key={index} className="time bg"></li>;
                      }

                      return <li key={item} className="time"></li>;
                    })}
                  </ul>
                  <ul className="schedule_cell">
                    {rooms.map((item, index) => {
                      if (index === 2) {
                        return <li key={index} className="time bg"></li>;
                      }

                      return (
                        <li key={item} className="time">
                          {index === 8 && (
                            <div className="schedule_box" style={{top: '60px', height: '60px', width: '206px'}}>
                              [교육] 김예약103 <br />
                              신규교사 면접으로
                            </div>
                          )}
                        </li>
                      );
                    })}
                  </ul>
                  <ul className="schedule_cell">
                    {rooms.map((item, index) => {
                      if (index === 2) {
                        return <li key={index} className="time bg"></li>;
                      }

                      return <li key={item} className="time"></li>;
                    })}
                  </ul>
                  <ul className="schedule_cell">
                    {rooms.map((item, index) => {
                      if (index === 2) {
                        return <li key={index} className="time bg"></li>;
                      }

                      return <li key={item} className="time"></li>;
                    })}
                  </ul>
                  <ul className="schedule_cell">
                    {rooms.map((item, index) => {
                      if (index === 2) {
                        return <li key={index} className="time bg"></li>;
                      }

                      return <li key={item} className="time"></li>;
                    })}
                  </ul>
                  <ul className="schedule_cell">
                    {rooms.map((item, index) => {
                      if (index === 2) {
                        return <li key={index} className="time bg"></li>;
                      }

                      return <li key={item} className="time"></li>;
                    })}
                  </ul>
                  <ul className="schedule_cell">
                    {rooms.map((item, index) => {
                      if (index === 2) {
                        return <li key={index} className="time bg"></li>;
                      }

                      return <li key={item} className="time"></li>;
                    })}
                  </ul>
                  <ul className="schedule_cell">
                    {rooms.map((item, index) => {
                      if (index === 2) {
                        return <li key={index} className="time bg"></li>;
                      }

                      return <li key={item} className="time"></li>;
                    })}
                  </ul>
                  <ul className="schedule_cell">
                    {rooms.map((item, index) => {
                      if (index === 2) {
                        return <li key={index} className="time bg"></li>;
                      }

                      return <li key={item} className="time"></li>;
                    })}
                  </ul>
                  <ul className="schedule_cell">
                    {rooms.map((item, index) => {
                      if (index === 2) {
                        return <li key={index} className="time bg"></li>;
                      }

                      return <li key={item} className="time"></li>;
                    })}
                  </ul>
                  <ul className="schedule_cell">
                    {rooms.map((item, index) => {
                      if (index === 2) {
                        return <li key={index} className="time bg"></li>;
                      }

                      return <li key={item} className="time"></li>;
                    })}
                  </ul>
                  <ul className="schedule_cell">
                    {rooms.map((item, index) => {
                      if (index === 2) {
                        return <li key={index} className="time bg"></li>;
                      }

                      return <li key={item} className="time"></li>;
                    })}
                  </ul>
                  <ul className="schedule_cell">
                    {rooms.map((item, index) => {
                      if (index === 2) {
                        return <li key={index} className="time bg"></li>;
                      }

                      return <li key={item} className="time"></li>;
                    })}
                  </ul>
                </div>
              </div>
            </section>
          </section>
        </section>
      </div>
      <_PopReservationClassRoom open={modalClassRoomOpen} close={() => setModalClassRoomOpen(false)} />
      <_PopManageReservation open={modalReservationOpen} close={() => setModalReservationOpen(false)} />
    </main>
  );
};

export default ReservationRoom;
